import { useHistory } from "react-router-dom";
import { TextInput } from "../TextInput";
import axios from "axios";
import { API } from "../../api/api";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useState } from "react";
import { Button } from "@mui/material";

let msgAlert = {
  title: 'Pesan',
  icon: 'success',
  text: 'Pengaturan ulang kata sandi berhasil. Silakan cek email anda di spam untuk konfirmasi kata sandi'
}

const FormForgotPassword = ({ setIsReset }) => {
  const [email, setEmail] = useState('');

  const history = useHistory();
  const MySwal = withReactContent(Swal);

  const onReset = async () => {
    try {
      setIsReset(true);

      const res = await axios.post(API.forget_password, {
        email
      }, {
        headers: {
          'Platform': 'map'
        }
      })

      if (res.status !== 200) {
        throw res;
      }

      msgAlert = {
        ...msgAlert,
        title: 'Pengaturan ulang kata sandi berhasil',
        text: res.data.message
      }

      setIsReset(false);
      setEmail('');

    } catch (error) {
      msgAlert = {
        title: 'Pesan',
        icon: 'error',
        text: 'Pengaturan ulang kata sandi gagal',
      }

      setIsReset(false);
    } finally {
      MySwal.fire({
        title: msgAlert.title,
        icon: msgAlert.icon,
        text: msgAlert.text,
      });
    }
  };

  const [hoverSubmit, setHoverSubmit] = useState(false)

  return (
    <form onSubmit={onReset}>
      <h4 className="mb-4">Lupa Kata Sandi</h4>
      <TextInput
        label="Email"
        value={email}
        onChange={(event) => {
          setEmail(event.target.value);
        }}
        minLength={5}
        maxLength={150}
        placeholder="Masukan Alamat Email"
        type="email"
        required
      />

      <Button variant={hoverSubmit ? 'outlined' : 'contained'}
        color='primaryMAP'
        fullWidth
        type="submit"
        sx={{
          marginTop: '10px'
        }}
        onMouseLeave={() => setHoverSubmit(false)} onMouseEnter={() => setHoverSubmit(true)}>Atur Ulang Kata Sandi</Button>

      <p className="text-center mt-4">
        Sudah punya akun?
        <a
          className="ml-1"
          style={{ color: 'green', cursor: 'pointer' }}
          onClick={() =>
            history.push('/login', {
              pageChannel: 'Forget Password Page',
            })
          }
        >
          Login di sini
        </a>
      </p>
    </form>
  )
}

export default FormForgotPassword;